// Push + Telegram endpoints — Home Automation api/new/notify.js.
//
// ⚠️ The backend endpoints ship with the server, not the app. Until that deploy
// the server answers them with an HTML 404, so every caller here treats "not
// JSON" as "not available yet" rather than as data.

import { post } from './api';

const json = (res) => (res && res.data && typeof res.data === 'object' ? res.data : null);

/** -> { ok, configured, linked, link, botUsername } | null (endpoint absent) */
export async function getTelegramLinkInfo(userId) {
  try { return json(await post('GetTelegramLinkInfo', { UserId: Number(userId) })); } catch { return null; }
}

export async function unlinkTelegram(userId) {
  return json(await post('UnlinkTelegram', { UserId: Number(userId) }));
}

/** -> { ok, push:{sent,failed,dead,noToken}, telegram:{sent,failed,notLinked} } */
export async function sendTestNotification(userId, { sound, channels, imageUrl } = {}) {
  return json(await post('SendTestNotification', {
    UserId: Number(userId), Sound: sound, Channels: channels, ImageUrl: imageUrl,
  }));
}

/** -> true when the server stored it; false when the endpoint is not there yet. */
export async function registerPushToken(userId, token) {
  const d = json(await post('RegisterPushToken', { UserId: Number(userId), Token: token }));
  return !!(d && d.ok);
}
